// extracted by mini-css-extract-plugin
export default {"box36":"WHoj7Y","box56":"oTm9J7"};